<template>
  <div :class="{ 'mds-menu--sticky': isSticky }" class="mds-menu mds-menu__contextual-menu">
    <pop-over
      :position="position"
      :popped="isMenuPopped"
      :size="size"
      @change="handlePopOverChange"
    >
      <template slot="clickTrigger">
        <slot name="clickTrigger">
          <button
            class="mds-popover__trigger"
            type="button"
            data-mds-popover="mds-popover"
            aria-haspopup="true"
            aria-expanded="true"
            aria-controls="mds-popover--8809"
            role="button"
          >
            <mds-icon name="caret-down" class="mds-icon mds-button__icon mds-button__icon--right" />
          </button>
        </slot>
      </template>
      <span v-if="heading" slot="header">{{ heading }}</span>
      <ul class="mds-list-group" role="menu">
        <li
          v-for="option in options"
          :key="option.id"
          :value="option.text"
          :class="{
            'mds-list-group__item--disabled': option.disabled,
            'mds-list-group__item--active': option.id === selectedId,
          }"
          class="mds-list-group__item"
        >
          <a
            v-if="!option.link"
            :href="'#'"
            class="mds-list-group__link"
            role="menuitem"
            @click="(event) => handleClick(event, option)"
          >
            <span class="mds-list-group__item-text"> {{ option.text }} </span>
            <mds-icon
              name="check"
              v-if="option.id === selectedId"
              class="mds-icon mds-button__icon mds-icon mds-list-group__active-icon"
            />
          </a>
          <router-link v-else :to="option.link" class="mds-list-group__link" role="menuitem">
            <span class="mds-list-group__item-text"> {{ option.text }} </span>
            <check-mark-icon
              v-if="option.id === selectedId"
              class="mds-icon mds-button__icon mds-icon mds-list-group__active-icon"
            />
          </router-link>
        </li>
      </ul>
    </pop-over>
  </div>
</template>

<script>
import MdsIcon from '@mds/icon';
import PopOver from 'mds-vue/src/components/PopOver';

export default {
  name: 'contextual-menu',
  components: {
    PopOver,
    MdsIcon,
  },
  props: {
    position: {
      type: String,
      default: 'bottom-center',
      validator(position) {
        return [
          'top-center',
          'top-right',
          'top-left',
          'bottom-center',
          'bottom-right',
          'bottom-left',
          'right-center',
          'right-top',
          'right-bottom',
          'left-center',
          'left-top',
          'left-bottom',
        ].some((allowedPosition) => allowedPosition === position);
      },
    },
    size: {
      type: String,
      default: '200px',
    },
    text: {
      type: String,
      required: true,
    },
    heading: {
      type: String,
      required: false,
      default: '',
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    selectedId: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: true,
      validator(options) {
        if (!options || !options.length) {
          return false;
        }

        return options.every(
          (option) => !!option
            && undefined !== option.id
            && !!option
            && typeof option.text === 'string'
            && !!option
            && (typeof option.link === 'string' || undefined === option.link)
            && !!option.id.trim()
            && typeof option.id === 'string'
            && !!option.id.trim(),
        );
      },
    },
    buttonType: {
      type: String,
      required: false,
      default: 'primary',
      validator(type) {
        return ['primary', 'secondary', 'flat'].some((allowedTypes) => allowedTypes === type);
      },
    },
  },
  data() {
    return {
      isMenuPopped: false,
    };
  },
  methods: {
    handleClick(event, option) {
      if (!option.link) {
        event.preventDefault();
      }
      this.isMenuPopped = false;
      this.$emit('selected', option);
    },
    handlePopOverChange(event, popped) {
      this.isMenuPopped = popped;
    },
  },
};
</script>
<style lang="scss">
body .mds-menu .mds-popover {
  z-index: 1000;
}
</style>
